// extracted by mini-css-extract-plugin
export var component = "jobs-widget-module--component--164g0";